import React, { Component } from "react";
import { Button, Input, Table, Modal, message, Popconfirm } from 'antd';
import styled from 'styled-components';
import StoreAPI from '@/api/store';
import utils from '@/utils/auth';
import moment from 'moment';
const { Search } = Input;
const Container = styled.div`
  .search-wrapper {
    display: flex;
    padding: 25px;
    margin-bottom: 30px;
    background-color: #fafafa;
    .search {
      display: flex;
      align-items: center;
      .search-input {
        width: 260px;
      }
    }
    .auth-alert {
      margin-left: 40px;
    }
  }
`;
const StoreContainer = styled.div`
  width: 700px;
  margin: 20px 0 0 20px;
`;
const StoreSettingsWrapper = styled.div`
  .top {
    display: flex;
    .item {
      width: calc(100% / 7);
      text-align: center;
      cursor: pointer;
      font-weight: 500;
      &.active {
        color: #FB001B;
      }
    }
  }

  .content {
    .wrapper {
      position: relative;
      width: 100%;
      padding-left: 50px;
      .left-before {
        position: absolute;
        top: 50px;
        left: 0;
        width: 50px;
        z-index: 9;
        line-height: 0;
        .time {
          font-size: 14px;
          &:nth-child(n) {
            margin-bottom: 50px;
          }
        }
      }
      .wrapper-content {
        position: relative;
        width: 100%;
        padding-top: 50px;
        overflow-x: scroll;
        .body {
          width: 100%;
          border: 1px solid #dddddd;
          tr {
            display: table-row;
            width: 100%;
            th {
              position: relative;
              flex: 1;
              min-width: 50px;
              height: 50px;
              cursor: pointer;
              border: 1px solid #dddddd;
              .block {
                width: 100%;
                height: 100%;
                &.occupy {
                  background-color: #F0F0F0;
                }
              }
              .line {
                position: absolute;
                left: 0;
                right: 0;
                bottom: calc(100% + 10px);
                font-weight: normal;
                margin: 0 auto;
              }
              .time {
                position: absolute;
                top: 0;
                transform: translateY(-50%);
                right: calc(100% + 10px);
                font-weight: normal;
              }
            }
          }
        }
      }
    }
  }

`;

export default class StoreInventory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams: {
        keyword: '',
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      storeList: [],

      storeSettingsVisible: false,
      itemKdtId: '',
      week: [],
      nowDate: '',
      dateTimeList: [],

      hundredStoreList: [
        {
          kdtId: 119414624,
          kdtName: '仲正堂推拿艾灸(梅川路店)',
        },
        {
          kdtId: 120875805,
          kdtName: '仲正堂推拿艾灸(漕宝路店)',
        },
        {
          kdtId: 44087901,
          kdtName: '仲正堂推拿艾灸(江阴街店)'
        },
        {
          kdtId: 114024211,
          kdtName: '仲正堂推拿艾灸(七宝店)'
        },
        {
          kdtId: 121522204,
          kdtName: '仲正堂推拿艾灸(大渡河店)'
        },
        {
          kdtId: 98277200,
          kdtName: '仲正堂推拿艾灸(大连路店）'
        }
      ],
    };
  }

  componentDidMount() {
    if (utils.isUserHeadQuarter()) {
      this.queryStoreInventoryList();
    } else {
      this.queryStoreItemInventoryDetail();
    }
  }

  queryStoreInventoryList = () => {
    const { searchParams } = this.state;
    StoreAPI.queryStoreInventoryList(searchParams)
      .then(({ items: storeList, paginator }) => {
        const { totalCount: total } = paginator;
        this.setState({ storeList, total });
      });
  }

  onSearch = () => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: 1 }) }, this.queryStoreInventoryList);
  }

  onPageChange = (current, pageSize) => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: current, pageSize }) }, this.queryStoreInventoryList);
  }

  showModal = ({ kdtId }) => {
    const week = this.getLastWeekDates();
    this.setState({
      week,
      nowDate: week[0].date,
      itemKdtId: kdtId,
    }, () => {
      this.queryDateTimeList(() => this.setState({ storeSettingsVisible: true }));
    });
  }

  queryStoreItemInventoryDetail() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const week = this.getLastWeekDates();
    const { kdtId } = userInfo;
    if (!kdtId) return false;
    this.setState({
      week,
      nowDate: week[0].date,
      itemKdtId: kdtId,
    }, this.queryDateTimeList);
  }

  queryDateTimeList = (cb) => {
    const { hundredStoreList, nowDate, itemKdtId: kdtId } = this.state;
    if (!nowDate) return false;
    const occupyDate = `${new Date().getFullYear()}-${nowDate}`;
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const { kdtId: rootKdtId } = userInfo;
    let num = 4;
    const newDate = new Date().getTime();
    const startTime = new Date('2024-05-23 23:00:00').getTime();
    const endTime = new Date('2024-05-24 05:00:00').getTime();

    if (hundredStoreList.map(o => o.kdtId).includes(rootKdtId) && (newDate >= startTime && newDate < endTime)) num = 100;
    let arr = [];
    for (let i = 0; i < num; i++) {
      arr.push(i + 1);
    }

    StoreAPI.queryStoreInventoryItemDetail({ kdtId, occupyDate })
      .then(res => {
        if (res.length) {
          const { occupiedStock: body } = res[0];
          const dateTimeList = body.map(o => {
            const { occupyBegin } = o;
            return Object.assign({}, o, { time: occupyBegin, value: arr || [0, 1, 2, 3] })
          });

          this.setState({ dateTimeList });
          cb && cb();
        }
      });
  }

  onDateChange = ({ date }) => {
    message.loading({
      content: '切换日期中...',
      duration: .15
    });
    this.setState({ nowDate: date }, this.queryDateTimeList);
  }

  onStoreInventoryConfirm = ({ item, date, index }) => {
    const { itemKdtId: kdtId, nowDate } = this.state;
    const { occupyBegin, occupyEnd, occupyBlock = [] } = item;
    let newBlock = [];
    if (occupyBlock.includes(index)) { // 存在，则是移除占用
      newBlock = occupyBlock.filter(o => o !== index);
    } else {
      newBlock = [...occupyBlock];
      newBlock.push(index); // 否则，是添加占用
    }
    const obj = {
      kdtId,
      occupyBegin,
      occupyEnd,
      occupyDate: `${new Date().getFullYear()}-${nowDate}`,
      occupyStock: newBlock.length,
      occupyBlock: newBlock
    };
    StoreAPI.updateStoreInventoryItem(obj)
      .then(() => {
        message.success('更新成功');
        this.queryDateTimeList();
      });
  }

  storeInventoryContent = () => {
    const status = utils.checkUserHasBtnPermission(this.props.location.pathname);
    const { week, dateTimeList, nowDate } = this.state;
    return (
      <StoreSettingsWrapper>
        <div className="top">
          {
            week.map(item =>
              <div key={item.date} className={`item ${nowDate === item.date ? 'active' : ''}`} onClick={() => this.onDateChange(item)}>
                <div className="week">{item.week}</div>
                <div className="date">{item.date}</div>
              </div>
            )
          }
        </div>

        <div className="content">
          <div className="wrapper">
            <div className="left-before">
              {dateTimeList.map(item => {
                return item.value.map((o, index) => index === 0 && <div key={index} className="time">{item.time}</div>)
              })}
            </div>
            <div className="wrapper-content">
              <table className="body">
                <tbody>
                  {
                    dateTimeList.map((item, i) =>
                      <tr key={item.time}>
                        {
                          item.value.map((o, index) =>
                            <th key={index}>
                              <Popconfirm
                                title={`${item.occupyBlock.includes(index + 1) ? '移除' : '确认'}占用？`}
                                onConfirm={() => this.onStoreInventoryConfirm({ item, date: item.time, index: index + 1 })}
                                disabled={!status}
                                okText="确认"
                                cancelText="取消"
                              >
                                <div className={`block ${item.occupyBlock.includes(index + 1) ? 'occupy' : ''}`}></div>
                              </Popconfirm>
                              {
                                i === 0 && <span className="line">{index + 1}</span>
                              }
                            </th>
                          )
                        }
                      </tr>
                    )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </StoreSettingsWrapper>
    )
  }

  getLastWeekDates = () => {
    let dates = [];
    for (let i = 0; i < 7; i++) {
      let date = new Date();
      date.setDate(date.getDate() + i);
      let dayOfWeek = date.getDay();
      let dayOfWeekName;

      // 将数字表示的周几转换为英文名称
      switch (dayOfWeek) {
        case 0: dayOfWeekName = '周日'; break;
        case 1: dayOfWeekName = '周一'; break;
        case 2: dayOfWeekName = '周二'; break;
        case 3: dayOfWeekName = '周三'; break;
        case 4: dayOfWeekName = '周四'; break;
        case 5: dayOfWeekName = '周五'; break;
        default: dayOfWeekName = '周六'; break;
      }

      dates.push({
        week: dayOfWeekName,
        date: moment(date).format('MM-DD'),
      });
    }
    return dates;
  }

  render() {
    const status = utils.checkUserHasBtnPermission(this.props.location.pathname);
    const { searchParams, storeList, total, storeSettingsVisible } = this.state;
    const columns = [
      {
        title: '美团店铺名称',
        dataIndex: 'mtShopName',
        key: 'mtShopName'
      },
      {
        title: '美团店铺ID',
        dataIndex: 'mtShopId',
        key: 'mtShopId'
      },
      {
        title: '操作',
        render: ({ kdtId }) => <Button type="link" disabled={!status} onClick={() => this.showModal({ kdtId })}>编辑</Button>
      }
    ];

    return (
      utils.isUserHeadQuarter() ?
        <Container>
          <div className="search-wrapper">
            <div className="search">
              <span className="label">美团店铺名称：</span>
              <Search
                allowClear
                enterButton="搜索"
                value={searchParams.keyword}
                placeholder="请输入店铺名称/ID"
                className="search-input"
                onSearch={this.onSearch}
                onChange={e => {
                  const value = e.target.value;
                  this.setState({ searchParams: Object.assign(searchParams, { keyword: value }) });
                }}
              />
            </div>
          </div>

          <div className="content-wrapper">
            <Table
              rowKey="mtShopId"
              columns={columns}
              dataSource={storeList}
              pagination={{
                current: searchParams.pageNum,
                pageSize: searchParams.pageSize,
                total,
                showTotal: total => `共${total}条`,
                hideOnSinglePage: false,
                onChange: this.onPageChange
              }}
            />
          </div>

          <Modal
            title="门店时段库存配置"
            maskClosable={false}
            width={700}
            open={storeSettingsVisible}
            onCancel={() => this.setState({ storeSettingsVisible: false })}
            footer={[
              <Button key="close" onClick={() => this.setState({ storeSettingsVisible: false })}>关闭</Button>
            ]}
          >
            {this.storeInventoryContent()}
          </Modal>
        </Container>
        :
        <StoreContainer>{this.storeInventoryContent()}</StoreContainer>
    );
  }
}
